


import { Vue, Component, Prop } from 'vue-property-decorator';

// TODO: better component name and refactoring
// This component, by graphic design, is only for
// meeting.communication_type — online, offline or expired (meeting date has passed)

@Component
export default class OnlineIndicator extends Vue {

  @Prop({ type: Number, default: 0 })
  public contactId: number;

  @Prop({
    type: String,
    default: 'offline',
    validator: (value: string) => {
      return ['online', 'offline', 'expired'].includes(value);
    }
  })
  public readonly indicatorType: string;

}

